import { IntegrationSettingsData } from '../Settings.types';

export enum EApiVersion {
  V1 = 'V1',
  V2 = 'V2'
}

export enum ESavingForm {
  NONE = 'none',
  PROJECT_INFO = 'projectInfo',
  PORTAL_INFO = 'portalInfo',
  AUTH_PLAYER = 'authPlayer',
  OTP = 'otp',
  GRANT_AWARD = 'grantAward',
  PERSONALIZE = 'personalize',
  EVENTS_WEBHOOK = 'eventsWebhook',
  APPSFLYER = 'appsFlyer',
  APPSFLYER_S2S = 'appsFlyerS2S'
}

export type ExtendedIntegrationData = IntegrationSettingsData & {
  awardingV2ApiUrl?: string;
  awardingV2Ratio?: number;
};

export interface IVersionConfig {
  version: string;
  label: string;
  value: string;
  initialValue?: string;
  onChange: (value: string) => void;
  error?: string;
  afterUrlField?: React.ReactNode;
  docsUrl?: string;
  isSelected?: boolean;
  initialIsSelected?: boolean;
  onSelectVersion?: () => void;
  urlDataTestId?: string;
}
